import { axiosInstanceWebsite } from "../../instance";
import { LoginGoogleAxiosInterface } from "./loginGoogleAxiosInterface";

export interface SendCodeEmailAxiosInterface {
  email: string;
}
export interface VerifyCodeAxiosInterface {
  email: string;
  code: string;
}

export const postLoginWithGoogle = async (data: LoginGoogleAxiosInterface) => {
  const response = await axiosInstanceWebsite.post('/user/login-google',
    data
  );
  return response.data;
};

export const postSendCodeEmail = async (data: SendCodeEmailAxiosInterface) => {
  const response = await axiosInstanceWebsite.post('/user/request-verification-code',
    data
  );
  return response.data;
};

export const postVerifyCode = async (data: VerifyCodeAxiosInterface) => {
  const response = await axiosInstanceWebsite.post('/user/verify-code',
    data
  );
  return response.data;
};

export const postRegisterWithOffer = async (data: SendCodeEmailAxiosInterface) => {
  const response = await axiosInstanceWebsite.post('/user/register-with-offer',
    data
  );
  return response.data;
};